module.exports = __webpack_public_path__ + "img/sec-11-hankook.f0ab0459.svg";